import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BaseLock, BaseProps, FormManager } from '@/uiManagers/FormManager'
import { Uuid } from '@/types/api'
import { computed, onBeforeMount, reactive, ref } from 'vue'
import { PromiseParallelAction } from '@/helpers/tools'
import { Calendar } from '@/types/api/calendar'
import { CalendarWrite } from '@/api/CalendarsApi'
import { calendarsApi } from '@/di/api'
import eventBus from '@/di/eventBus'
import { useRouter } from "vue-router";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";

interface Props extends BaseProps {
  itemId?: Uuid,
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Lock extends BaseLock {
}

type Model = CalendarWrite


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarForm',
  props: {
    itemId: null
  },
  setup(__props: any) {

const props = __props as {
  itemId?: Uuid,
};

class CalendarFormManager extends FormManager<Calendar, Props, Lock> {

}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
const router = useRouter()


const model = ref<Model>({ weight: 0, title: '', description: '' })
const lock = reactive<Lock>({ preparing: false, formSubmitting: false })

const calendarFormManager: CalendarFormManager = new CalendarFormManager(
    'calendar',
    router,
    eventBus,
    props,
    (): Model => ({
      weight: parseInt('' + model.value.weight),
      title: model.value.title,
      description: model.value.description || null
    }),
    lock,
    {
      resolveItem: (itemId: Uuid): PromiseParallelAction<Calendar> => ({
        promise: () => calendarsApi.getCalendar(itemId),
        resolve: (calendar): void => {
          model.value.weight = calendar.weight
          model.value.title = calendar.title
          model.value.description = calendar.description || ''
        }
      } as PromiseParallelAction<Calendar>),
      create: ((submitData: Model): Promise<void> => calendarsApi.createCalendar(submitData)) as (submitData: object) => Promise<void>,
      update: ((id: Uuid, submitData: Model): Promise<void> => calendarsApi.updateCalendar(id, submitData)) as (id: Uuid, submitData: object) => Promise<void>
    },
    {},
    { name: 'calendars-list' }
)

const submitButtonText = computed<string>((): string => calendarFormManager.isCreate() ? 'Add' : 'Update')

const submit = calendarFormManager.getSubmit()

onBeforeMount(async (): Promise<void> => {
  await calendarFormManager.prepareForm()
})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    type: "form",
    actions: false,
    onSubmit: _unref(submit)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_FormKit, {
        name: "weight",
        type: "number",
        label: "Weight",
        validation: "required",
        disabled: lock.preparing,
        "outer-class": "mb-3"
      }, null, 8, ["disabled"]),
      _createVNode(_component_FormKit, {
        name: "title",
        type: "text",
        label: "Title",
        validation: "required",
        disabled: lock.preparing,
        "outer-class": "mb-3"
      }, null, 8, ["disabled"]),
      _createVNode(_component_FormKit, {
        name: "description",
        type: "textarea",
        label: "Description",
        disabled: lock.preparing,
        "outer-class": "mb-3"
      }, null, 8, ["disabled"]),
      _createVNode(_component_FormKit, {
        type: "submit",
        label: _unref(submitButtonText),
        "input-class": "btn btn-primary btn-sm",
        disabled: lock.preparing
      }, {
        default: _withCtx(() => [
          _createVNode(FormKitSubmitButtonContent, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(submitButtonText)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue", "onSubmit"]))
}
}

})